import React, { useEffect, useState } from 'react'
import Draggable from 'react-draggable'
import styled from 'styled-components'
import Marker from '../../interfaces/Marker'

interface IProps {
    _handleDraggableOnStop: any
    barRef: any
    width: number
    markers: Marker[]
}

const initialPosition = { x: 0, y: 0 }

const DraggableCustom = ({ _handleDraggableOnStop, barRef, width, markers }: IProps) => {
    const [position, setPosition] = useState<any>(initialPosition)

    useEffect(() => {
        setPosition(initialPosition)
    }, [width, markers])

    const _handleOnStop = (event, ui) => {
        _handleDraggableOnStop(event, ui, barRef?.current?.clientWidth)
        setPosition({ x: ui.lastX, y: 0 })
    }

    return (
        <Container className="draggable-custom-container">
            <Draggable
                bounds={{ top: 0, left: 0, right: barRef?.current?.clientWidth, bottom: 0 }}
                position={position}
                onStart={(event, ui) => _handleOnStop(event, ui)}
                onStop={(event, ui) => _handleOnStop(event, ui)}
            >
                <div className="drag-box draggable-cursor"></div>
            </Draggable>
        </Container>
    )
}

export default DraggableCustom

const Container = styled.div`
    position: relative;
    top: -16px;
    width: 100%;
    height: 16px;

    .draggable-cursor {
        height: 30px;
        position: relative;
        width: 9px;
        background: #fff;
        transform: translate(74px, 0px);
        top: -17px;
        left: -4px;
        border: 2px solid black;
        cursor: url('/content/plugin-widget-gmaps/hand-pointer.svg'), auto;
    }
`
